"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
var _typeof = require("@babel/runtime/helpers/typeof");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime/helpers/slicedToArray"));
var _react = _interopRequireWildcard(require("react"));
var _propTypes = require("prop-types");
var _reactstrap = require("reactstrap");
var _ = require("../..");
var _hooks = require("../../hooks");
var _reactFontawesome = require("@fortawesome/react-fontawesome");
var _PermissionTooltip = _interopRequireDefault(require("../Permissions/PermissionTooltip"));
var _SourcePropType = _interopRequireDefault(require("../SourcePropType"));
var _freeSolidSvgIcons = require("@fortawesome/free-solid-svg-icons");
var _SourceListItemSettingsMenu = require("./SourceListItemSettingsMenu.styled");
var _broadcastSourceHelper = require("../../utils/broadcastSourceHelper");
var _PopOverPresentationControl = require("../PopOverPresentationControl");
function _interopRequireWildcard(e, t) { if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap(); return (_interopRequireWildcard = function _interopRequireWildcard(e, t) { if (!t && e && e.__esModule) return e; var o, i, f = { __proto__: null, "default": e }; if (null === e || "object" != _typeof(e) && "function" != typeof e) return f; if (o = t ? n : r) { if (o.has(e)) return o.get(e); o.set(e, f); } for (var _t in e) "default" !== _t && {}.hasOwnProperty.call(e, _t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, _t)) && (i.get || i.set) ? o(f, _t, i) : f[_t] = e[_t]); return f; })(e, t); }
var SourceListItemSettingsMenu = function SourceListItemSettingsMenu(_ref) {
  var _value$numPages;
  var source = _ref.source,
    enableFeature = _ref.enableFeature,
    onSourceEdited = _ref.onSourceEdited,
    onSourceDeleted = _ref.onSourceDeleted,
    _ref$canEdit = _ref.canEdit,
    canEdit = _ref$canEdit === void 0 ? true : _ref$canEdit,
    isStaged = _ref.isStaged,
    live = _ref.live,
    onSetSourceUnassigned = _ref.onSetSourceUnassigned,
    _ref$isDirectorSource = _ref.isDirectorSource,
    isDirectorSource = _ref$isDirectorSource === void 0 ? false : _ref$isDirectorSource,
    onAssignSpeakers = _ref.onAssignSpeakers,
    onReplaceSlides = _ref.onReplaceSlides,
    onGoToPresentationPage = _ref.onGoToPresentationPage;
  var sourceId = source._id,
    disconnected = source.disconnected,
    isInitializing = source.isInitializing,
    thumbnail = source.thumbnail,
    type = source.type,
    value = source.value;
  var isStudioLite = (0, _hooks.useStudioLiteContext)();
  var _useState = (0, _react.useState)(false),
    _useState2 = (0, _slicedToArray2["default"])(_useState, 2),
    dropdownOpen = _useState2[0],
    setDropdownOpen = _useState2[1];
  var targetElementId = "source-list-item-settings-menu-".concat(sourceId);
  var _useState3 = (0, _react.useState)(false),
    _useState4 = (0, _slicedToArray2["default"])(_useState3, 2),
    popoverOpen = _useState4[0],
    setPopoverOpen = _useState4[1];
  var togglePopover = function togglePopover() {
    setPopoverOpen(!popoverOpen);
  };
  var toggle = function toggle(event) {
    var _popOverElement$conta;
    var popOverElement = document.querySelector('#popover');
    var insidePopOverClick = (_popOverElement$conta = popOverElement === null || popOverElement === void 0 ? void 0 : popOverElement.contains(event.target)) !== null && _popOverElement$conta !== void 0 ? _popOverElement$conta : false;
    var id = event.target.id;
    if (id === 'goToSlideNumberSelector' || insidePopOverClick) {
      return;
    }
    enableFeature && setDropdownOpen(!dropdownOpen);
    setPopoverOpen(false);
  };
  var isPresentationControlV2Feature = (0, _.shouldHaveFeature)('studio.presentationControlV2');
  var isPresentationControlV2 = isPresentationControlV2Feature && type === _.PDF_FILE;
  var isPresentationControl = type === _.PDF_FILE;
  var showGoToPresentationPopover = ((_value$numPages = value === null || value === void 0 ? void 0 : value.numPages) !== null && _value$numPages !== void 0 ? _value$numPages : 0) > 0 && isPresentationControl;
  var canUnassignSource = [_.SCREEN_PRESENTER].includes(type) && value !== _broadcastSourceHelper.UNASSIGNED;
  var isValidThumbnail = thumbnail && thumbnail !== _broadcastSourceHelper.EMPTY_THUMBNAIL;
  var isUnassigned = value === _broadcastSourceHelper.UNASSIGNED;
  var hasStartedScreenShare = type === _.SCREEN_PRESENTER && isValidThumbnail && !isInitializing && !isUnassigned;
  var deleteVerbiage = 'Delete';
  if (hasStartedScreenShare) {
    deleteVerbiage = 'Stop screen share';
  }
  var showDeleteOption = !(value !== 'Unassigned' && type === 'cameraPresenter' && !disconnected && !isInitializing);
  var sourceActionVerbiage = isDirectorSource ? 'Director' : 'Speaker';
  var editMenuVerbiage = isPresentationControl ? 'Rename' : 'Settings';
  var handlePopoverSubmit = function handlePopoverSubmit(newPage) {
    onGoToPresentationPage(newPage);
    setPopoverOpen(false);
    setDropdownOpen(false);
  };
  var handlePopoverCancel = function handlePopoverCancel() {
    setPopoverOpen(false);
    setDropdownOpen(false);
  };
  var handleKeyDown = function handleKeyDown(e) {
    if (e.key === ' ' || e.key === 'Enter') {
      setDropdownOpen(true);
    }
  };
  return /*#__PURE__*/_react["default"].createElement(_SourceListItemSettingsMenu.Wrapper, {
    toggle: toggle,
    id: targetElementId,
    isOpen: dropdownOpen
  }, /*#__PURE__*/_react["default"].createElement(_SourceListItemSettingsMenu.ToggleWrapper, {
    tabIndex: "0",
    "aria-label": "Open source settings",
    "aria-haspopup": "true",
    "aria-expanded": dropdownOpen,
    $enableFeature: enableFeature,
    "data-testid": "sourceSettings_".concat(sourceId),
    "data-dd-action-name": "Open ".concat(sourceActionVerbiage, " ").concat(type, " source - ").concat(sourceId, " settings"),
    onKeyDown: function onKeyDown(e) {
      return handleKeyDown(e);
    }
  }, /*#__PURE__*/_react["default"].createElement(_reactFontawesome.FontAwesomeIcon, {
    icon: _freeSolidSvgIcons.faEllipsisH,
    color: live ? '#fff' : isStaged ? '#33373D' : '#fff'
  }), /*#__PURE__*/_react["default"].createElement("span", {
    className: "visually-hidden"
  }, "Open source settings")), /*#__PURE__*/_react["default"].createElement(_reactstrap.DropdownMenu, {
    end: true
  }, isPresentationControl && /*#__PURE__*/_react["default"].createElement(_SourceListItemSettingsMenu.DropdownMenuItem, {
    onClick: onAssignSpeakers,
    "data-testid": "assignSpeakers_".concat(sourceId),
    "data-dd-action-name": "Assign Speakers ".concat(type, " source - ").concat(sourceId)
  }, /*#__PURE__*/_react["default"].createElement(_SourceListItemSettingsMenu.DropdownMenuItemIcon, null, /*#__PURE__*/_react["default"].createElement(_reactFontawesome.FontAwesomeIcon, {
    icon: _freeSolidSvgIcons.faUserPlus
  })), "Assign speakers"), showGoToPresentationPopover && /*#__PURE__*/_react["default"].createElement(_SourceListItemSettingsMenu.DropdownMenuItem, {
    id: "goToSlideNumberSelector",
    "data-testid": "goToSlideNumber_".concat(sourceId),
    "data-dd-action-name": "Go to slide number ".concat(type, " source - ").concat(sourceId)
  }, /*#__PURE__*/_react["default"].createElement(_SourceListItemSettingsMenu.DropdownMenuItemIcon, null, /*#__PURE__*/_react["default"].createElement(_reactFontawesome.FontAwesomeIcon, {
    icon: _freeSolidSvgIcons.faLeftRight
  })), "Go to slide number"), showGoToPresentationPopover && /*#__PURE__*/_react["default"].createElement(_reactstrap.Popover, {
    id: "popover",
    trigger: "legacy",
    placement: "right",
    isOpen: popoverOpen,
    target: "goToSlideNumberSelector",
    toggle: togglePopover
  }, /*#__PURE__*/_react["default"].createElement(_SourceListItemSettingsMenu.StyledPopoverBody, {
    "data-testid": "popover-body"
  }, /*#__PURE__*/_react["default"].createElement(_PopOverPresentationControl.PopOverPresentationControl, {
    value: value,
    onSubmit: handlePopoverSubmit,
    onCancel: handlePopoverCancel
  }))), canEdit && /*#__PURE__*/_react["default"].createElement(_SourceListItemSettingsMenu.DropdownMenuItem, {
    onClick: onSourceEdited,
    "data-testid": "editSource_".concat(sourceId),
    "data-dd-action-name": "".concat(editMenuVerbiage, " - ").concat(sourceActionVerbiage, " ").concat(type, " source - ").concat(sourceId)
  }, /*#__PURE__*/_react["default"].createElement(_SourceListItemSettingsMenu.DropdownMenuItemIcon, null, /*#__PURE__*/_react["default"].createElement(_reactFontawesome.FontAwesomeIcon, {
    icon: isPresentationControl ? _freeSolidSvgIcons.faPenToSquare : _freeSolidSvgIcons.faCog,
    color: "#000"
  })), editMenuVerbiage), isPresentationControlV2 && /*#__PURE__*/_react["default"].createElement(_SourceListItemSettingsMenu.DropdownMenuItem, {
    onClick: onReplaceSlides,
    "data-testid": "replaceSlides_".concat(sourceId),
    "data-dd-action-name": "Replace Slides ".concat(type, " source - ").concat(sourceId)
  }, /*#__PURE__*/_react["default"].createElement(_SourceListItemSettingsMenu.DropdownMenuItemIcon, null, /*#__PURE__*/_react["default"].createElement(_reactFontawesome.FontAwesomeIcon, {
    icon: _freeSolidSvgIcons.faRepeat
  })), "Replace slides"), showDeleteOption && /*#__PURE__*/_react["default"].createElement(_SourceListItemSettingsMenu.DropdownMenuItem, {
    "data-dd-action-name": "Delete ".concat(sourceActionVerbiage, " ").concat(type, " source - ").concat(sourceId),
    onClick: onSourceDeleted,
    "data-testid": "deleteSource_".concat(sourceId)
  }, /*#__PURE__*/_react["default"].createElement(_SourceListItemSettingsMenu.DropdownMenuItemIcon, null, /*#__PURE__*/_react["default"].createElement(_reactFontawesome.FontAwesomeIcon, {
    icon: _freeSolidSvgIcons.faTrash,
    color: "#00000"
  })), deleteVerbiage), !isStudioLite && canUnassignSource && !hasStartedScreenShare && /*#__PURE__*/_react["default"].createElement(_SourceListItemSettingsMenu.DropdownMenuItem, {
    onClick: onSetSourceUnassigned,
    "data-testid": "unassignSource_".concat(sourceId),
    "data-dd-action-name": "Unassign ".concat(sourceActionVerbiage, " ").concat(type, " source - ").concat(sourceId)
  }, /*#__PURE__*/_react["default"].createElement(_SourceListItemSettingsMenu.DropdownMenuItemIcon, null, /*#__PURE__*/_react["default"].createElement(_reactFontawesome.FontAwesomeIcon, {
    icon: _freeSolidSvgIcons.faEraser,
    color: "#00000"
  })), "Unassign Placeholder")), /*#__PURE__*/_react["default"].createElement(_PermissionTooltip["default"], {
    displayTooltip: !enableFeature,
    targetElementId: targetElementId,
    requiredRole: 'Contributor, admin or show caller'
  }));
};
SourceListItemSettingsMenu.propTypes = {
  live: _propTypes.bool,
  canEdit: _propTypes.bool,
  isStaged: _propTypes.bool,
  enableFeature: _propTypes.bool,
  isDirectorSource: _propTypes.bool,
  source: _SourcePropType["default"],
  onSetSourceUnassigned: _propTypes.func,
  onSourceEdited: _propTypes.func.isRequired,
  onSourceDeleted: _propTypes.func.isRequired,
  onAssignSpeakers: _propTypes.func,
  onReplaceSlides: _propTypes.func,
  onGoToPresentationPage: _propTypes.func
};
var _default = exports["default"] = SourceListItemSettingsMenu;